module.exports = __webpack_public_path__ + "static/home-1e8dffdd13f5a218d80273b088c60b35.jpg";